import { render } from "./UserHome.vue?vue&type=template&id=2056a928&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=2056a928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2056a928"]])

export default __exports__